import TicketCuticle from '@/components/manage/TicketCuticle';
import type { ProfileBookingType } from '@/types/profile';
import { Skeleton } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface BookingItemSkeletonProps {
  bookingType: ProfileBookingType;
}

const TicketSkeleton = () => (
  <div className="flex flex-col">
    <div className="flex justify-between rounded-t-lg border border-neutral-light bg-neutral-pale p-3 laptop:p-4">
      <div className="flex flex-col gap-1 laptop:flex-row laptop:items-center laptop:gap-2">
        <Skeleton className="h-5 w-36" />
        <Skeleton className="h-4 w-28" />
      </div>
      <Skeleton className="h-5 w-16" />
    </div>
    <div className="flex flex-col gap-1 border-x border-neutral-light bg-white p-3 pb-6 laptop:p-4">
      <div className="flex items-center gap-2">
        <Skeleton className="h-5 w-20" />
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-5 w-20" />
      </div>
      <Skeleton className="h-4 w-44" />
    </div>
    <div className="bg-white">
      <TicketCuticle isVertical={false} />
    </div>
    <div className="flex rounded-b-lg border-x border-b border-neutral-light bg-white p-3 pt-6 laptop:grid laptop:grid-cols-3 laptop:p-4">
      <Skeleton className="h-12 w-full laptop:col-start-3" />
    </div>
  </div>
);

const VoucherSkeleton = () => (
  <div className="flex h-[150px] w-full flex-row rounded-lg bg-white">
    <div className="flex flex-1 flex-col gap-3 rounded-l-lg rounded-tr-none border border-r-0 border-neutral-light pb-2.5 pl-4 pr-2 pt-4">
      <Skeleton className="h-5 w-20 rounded" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-2 w-52" />
        <Skeleton className="mt-0.5 h-4 w-28" />
      </div>
    </div>
    <div className="h-full">
      <TicketCuticle isVertical />
    </div>
    <div className="flex w-[120px] flex-col justify-center gap-3 rounded-r-lg border border-l-0 border-neutral-light px-2 py-4 pr-4">
      <Skeleton className="h-3 w-14" />
      <Skeleton className="h-4 w-20" />
    </div>
  </div>
);

const BookingItemSkeleton: FC<BookingItemSkeletonProps> = ({ bookingType }) => {
  if (bookingType === 'vouchers') {
    return <VoucherSkeleton />;
  }
  return <TicketSkeleton />;
};

export default BookingItemSkeleton;
